export const TAB_NAMES = {
  AI: 'ai',
  API: 'api',
};
